var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('song-form',{attrs:{"addition":false,"id":_vm.id,"lang":_vm.lang},on:{"save":_vm.save,"cancel":_vm.cancel,"remove":_vm.remove}})}
var staticRenderFns = []

export { render, staticRenderFns }